import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContractType } from "src/models/HumanResources/ContractTypes.models";

interface ContractTypeState {
  contractTypes: IContractType[];
  contractTypeToEdit: IContractType | null;
}

const initialState: ContractTypeState = {
  contractTypes: [],
  contractTypeToEdit: null,
};

const ContractTypeSlice = createSlice({
  name: "ContractType",
  initialState,
  reducers: {
    setContractTypeList: (state, action: PayloadAction<IContractType[]>) => {
      state.contractTypes = action.payload;
    },
    concatListContractType: (
      state: ContractTypeState,
      action: PayloadAction<IContractType[]>
    ) => {
      state.contractTypes = [...state.contractTypes.concat(action.payload)];
    },
    setContractTypeToEdit: (
      state,
      action: PayloadAction<IContractType | null>
    ) => {
      state.contractTypeToEdit = action.payload;
    },
    addContractType: (state, action: PayloadAction<IContractType>) => {
      state.contractTypes.push(action.payload);
    },
    updateContractType: (state, action: PayloadAction<IContractType>) => {
      let itemIndex = state.contractTypes.findIndex(
        item => item.contractTypeId === action.payload.contractTypeId
      );
      if (itemIndex !== -1) state.contractTypes[itemIndex] = action.payload;
    },
    deleteContractType: (state, action: PayloadAction<number>) => {
      const newArray = state.contractTypes.filter(
        item => item.contractTypeId !== action.payload
      );
      state.contractTypes = newArray;
    },
  },
});

export const {
  setContractTypeList,
  concatListContractType,
  setContractTypeToEdit,
  addContractType,
  updateContractType,
  deleteContractType,
} = ContractTypeSlice.actions;

export default ContractTypeSlice.reducer;
